import { useWorkspace } from '@/features/workspaces/hooks';

/**
 * Gates the Market Intelligence section behind the per-workspace feature flag
 * served by the API as `workspace.features.marketIntelligence.active`.
 *
 * Turning it on is a DB-side operation, there is no UI for it. Merge into the existing
 * document rather than assigning it, or you drop every other flag on that workspace:
 *   UPDATE cdp_workspace
 *   SET features = (features::jsonb || '{"marketIntelligence":{"active":true}}'::jsonb)::json
 *   WHERE external_id = 'w-...';
 */
export const useMarketIntelligenceEnabled = (): boolean => !!useWorkspace().features?.marketIntelligence?.active;
